import { LitElement, html, unsafeCSS } from "lit";
import styles from "./styles/ds-gap.css?inline";

/**
 * Full-width vertical spacer.
 *
 * Usage:
 * - <ds-gap unit></ds-gap>
 * - <ds-gap double></ds-gap>
 * - <ds-gap size="05"></ds-gap>
 */
export class Gap extends LitElement {
  static properties = {
    /** Raw scale token selector ("01", "025", "05", "08", "1", "2", "3", "4", "8", "12") */
    size: { type: String, reflect: true },
  };

  declare size: string;

  constructor() {
    super();
    this.size = "";
  }

  static styles = unsafeCSS(styles);

  render() {
    return html``;
  }
}

customElements.define("ds-gap", Gap);

declare global {
  interface HTMLElementTagNameMap {
    "ds-gap": Gap;
  }
}
